import request from 'superagent';
import tree from '../state';
import config from '../config';

/* eslint-disable */

export function getProduct(sku) {

	let url = `${config.apiBase}/api/product/${sku}`;
	return request.get(url)
		.set('authorization', tree.get('token'))
		.set('site', 'client')
		.then(res => JSON.parse(res.text));
}

export function productSearch(data) {
	return request.get(`${config.apiBase}/api/productsearch`)
		.set('authorization', tree.get('token'))
		.set('site', 'client')
		.query(data)
		.then(res => JSON.parse(res.text));
}

export function getProductsToCompare(skus) {
	return request.get(`${config.apiBase}/api/product/compare`)
		.set('authorization', tree.get('token'))
		.query(skus)
		.then(res => JSON.parse(res.text));
}

export function getProductsSearch(skus) {
	return request.get(`${config.apiBase}/api/product/search?skuNumber=${skus}`)
		.set('authorization', tree.get('token'))
		.then(res => JSON.parse(res.text));
}


// WEBPACK FOOTER //
// ./src/services/productService.js